import React from 'react';
import './portfolio.scss';
import SmartMap from './smart_map.jpg';
import Card from '../Card';
// import Youtube from './youtube.jpg';
// import Game from './game.jpg';
import CP from './cult_portal.jpg';
// import Presentation from './presentaton.jpg';
import CV from './cv.jpg';
import Fifth from './ififteen.jpg';
// import AngularYoutube from './youtube-angular.jpg';
import TodoList from './todolist.jpg';
import homescapes from './homescapes.jpg';

const context = {
    en: {
        label1: 'SMART Map',
        tools1: [
            'Photoshop',
            'VS Code',
            'Webpack 4',
            'JavaScript',
            'Pug',
            'SCSS',
            'GitHub',
        ],
        // label2: "Youtube Client",
        // tools2: [
        //   "VS Code",
        //   "Webpack 4",
        //   "JavaScript",
        //   "SCSS",
        //   "Youtube API",
        //   "GitHub",
        // ],
        // label3: "Game",
        // tools3: [
        //   "Photoshop",
        //   "VS Code",
        //   "Webpack 4",
        //   "JavaScript",
        //   "SCSS",
        //   "Pug",
        //   "Bootstrap",
        //   "jQuery",
        //   "Express",
        //   "MongoDB",
        //   "Heroku",
        //   "GitHub",
        // ],
        label4: 'Cultural Portal. Team work',
        tools4: ['VS Code', 'React', 'JavaScript', 'SCSS', 'GitHub'],
        // label5: 'Presentation: "Ajax & Promises"',
        // tools5: ['VS Code', 'Reveal', 'HTML', 'GitHub'],
        label6: 'This CV',
        tools6: ['VS Code', 'React', 'JavaScript', 'SCSS', 'GitHub'],
        label7: 'Puzzle Game',
        tools7: ['VS Code', 'Angular 7', 'Typescript', 'SCSS', 'GitHub'],
        // label8: 'Youtube client on Angular 7',
        // tools8: ['VS Code', 'Angular 7', 'Typescript', 'SCSS', 'GitHub'],
        label9: 'ToDo list on Angular 7',
        tools9: [
            'VS Code',
            'Firebase',
            'Angular 7',
            'Angular Material',
            'Angular Drag & Drop',
            'Typescript',
            'SCSS',
            'GitHub',
        ],
        label10: 'Test task. Gamedev.',
        tools10: [
            'VS Code',
            'Javascript ES6',
            'PixiJS',
            'Canvas',
            'Webpack 5',
            'GitHub',
        ],
    },
    ru: {
        label1: 'Умная Карта',
        tools1: [
            'Photoshop',
            'VS Code',
            'Webpack 4',
            'JavaScript',
            'Pug',
            'SCSS',
            'GitHub',
        ],
        // label2: "Youtube Клиент",
        // tools2: [
        //   "VS Code",
        //   "Webpack 4",
        //   "JavaScript",
        //   "SCSS",
        //   "Youtube API",
        //   "GitHub",
        // ],
        // label3: "Игра",
        // tools3: [
        //   "Photoshop",
        //   "VS Code",
        //   "Webpack 4",
        //   "JavaScript",
        //   "SCSS",
        //   "Pug",
        //   "Bootstrap",
        //   "jQuery",
        //   "Express",
        //   "MongoDB",
        //   "Heroku",
        //   "GitHub",
        // ],
        label4: 'Культурный портал. Командная работа',
        tools4: ['VS Code', 'React', 'JavaScript', 'SCSS', 'GitHub'],
        // label5: 'Презентация: "Ajax & Promises"',
        // tools5: ['VS Code', 'Reveal', 'HTML', 'GitHub'],
        label6: 'Данное Резюме',
        tools6: ['VS Code', 'React', 'JavaScript', 'SCSS', 'GitHub'],
        label7: 'Пятнашки',
        tools7: ['VS Code', 'Angular 7 ', 'Typescript', 'SCSS', 'GitHub'],
        // label8: 'Youtube клиент на Angular 7',
        // tools8: ['VS Code', 'Angular 7', 'Typescript', 'SCSS', 'GitHub'],
        label9: 'Список дел на Angular 7',
        tools9: [
            'VS Code',
            'Firebase',
            'Angular 7',
            'Angular Material',
            'Angular Drag & Drop',
            'Typescript',
            'SCSS',
            'GitHub',
        ],
        label10: 'Тестовое задание. Геймдев.',
        tools10: [
            'VS Code',
            'Javascript ES6',
            'PixiJS',
            'Canvas',
            'Webpack 5',
            'GitHub',
        ],
    },
};

const Portfolio = ({ lang }) => {
    const {
        label1,
        tools1,
        // label2,
        // tools2,
        // label3,
        // tools3,
        label4,
        tools4,
        // label5,
        // tools5,
        label6,
        tools6,
        label7,
        tools7,
        // tools8,
        // label8,
        label9,
        tools9,
        label10,
        tools10,
    } = context[lang];
    return (
        <div className='Portfolio'>
            <Card
                image={TodoList}
                title={label9}
                link={'todo-list-angular'}
                tools={tools9}
            />
            <Card
                image={homescapes}
                title={label10}
                link={'pixi-test-task'}
                tools={tools10}
            />
            <Card
                image={SmartMap}
                title={label1}
                link={'smart-map'}
                tools={tools1}
            />
            {/* <Card image={Youtube} title={label2} link={"task"} tools={tools2} /> */}
            {/* <Card image={Game} title={label3} link={"result"} tools={tools3} /> */}
            <Card image={CP} title={label4} link={'codejam5'} tools={tools4} />
            {/* <Card
                image={Presentation}
                title={label5}
                link={'presentation'}
                tools={tools5}
            /> */}
            {/* <Card
                image={AngularYoutube}
                title={label8}
                link={'ahw4'}
                tools={tools8}
            /> */}
            <Card image={CV} title={label6} link={'CV'} tools={tools6} />
            <Card
                image={Fifth}
                title={label7}
                link={'num_puzzle'}
                tools={tools7}
            />
        </div>
    );
};

export default Portfolio;
